export default class ValidationService {

    public static checkValidEmail(email: string) {
        const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(email.toLowerCase());
    }

    public static checkValidProfesionalEmail(email: string) {
        return ! email.includes('shitmail');
    }

}
